import ReplyOptionButton from "@/ui/components/ReplyOptionButton";
import AppStoreTile from "@/ui/components/AppStoreTile";
import { useRef, useState, useLayoutEffect, useCallback } from "preact/hooks";

export default function ButtonRow({ replyOptions, onButtonClick }) {
  const containerRef = useRef(null);
  const [wrapped, setWrapped] = useState(false);
  const [disabled, setDisabled] = useState(false);

  // Dynamically switch between row and column layout:
  // If any button wraps to a new line (i.e., has a different offsetTop),
  // set 'wrapped' to true and use flex-col. Otherwise, use flex-row.
  // This ensures buttons are always in a single row if they fit, or a column if not.
  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const checkWrap = () => {
      const tops = Array.from(el.children).map((c) => c.offsetTop);
      setWrapped(tops.some((t, i) => i > 0 && t > tops[0]));
    };
    const observer = new ResizeObserver(checkWrap);
    observer.observe(el);
    checkWrap();
    return () => observer.disconnect();
  }, [replyOptions]);

  // Wrap the button click handler to disable all buttons immediately
  const handleButtonClick = useCallback(
    (replyOption) => {
      setDisabled(true);
      if (onButtonClick) onButtonClick(replyOption);
    },
    [onButtonClick]
  );

  return (
    <div
      ref={containerRef}
      className={`flex flex-wrap ${
        wrapped ? "flex-col items-end" : "flex-row items-center"
      } justify-end gap-2 relative`}
    >
      {replyOptions.map((replyOption) =>
        replyOption.type === "store_badge" ? (
          <AppStoreTile
            key={replyOption.selectionIntent}
            replyOption={replyOption}
            disabled={disabled}
          />
        ) : (
          <ReplyOptionButton
            key={replyOption.selectionIntent}
            replyOption={replyOption}
            handleButtonClick={handleButtonClick}
            disabled={disabled}
          />
        )
      )}
    </div>
  );
}
